import { StepProps, Steps } from "antd";
import { AppStyles } from "assets/styles";
import GeneralRepository from "core/data/GeneralRepository";
import { setHSBTipoRicercaRisorsaUmana, selectParametri } from "core/redux/features/parametri/parametriSlice";
import {  useAppSelector } from "core/redux/store/hooks";
import { useCallback, useEffect } from "react";


import "./ProgressBar.css";
//import { HSBTipoRicercaRisorsaUmanaEnum } from "types/HSBTipoRicercaRisorsaUmanaEnum";
import { formStep } from "types/StepEnums";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import NavigationManager from "utils/NavigationManager";
import useWindowDimensions from "utils/WindowSize";
import { Enhanced, IReactComponentBase } from "utils/ReactUtils";

interface IProgressBarProps  extends IReactComponentBase{
	current: number;
}

const ProgressBar: React.FC<IProgressBarProps> = ({ current ,sessionInfo,dispatch,handleError }) => {
	const { width } = useWindowDimensions();
	
	const parametriInfo = useAppSelector(selectParametri);
	
	const { GoToStep, getNextStep } = NavigationManager(sessionInfo);

	const HSBTipoRicercaRisorsaUmanaSet = useCallback(
		(parametro: any) => {
			dispatch(setHSBTipoRicercaRisorsaUmana(parametro));
		},
		[dispatch]
	);

	const getMaxStepNumber = () => {
		/* Vedere di spostare lo state nel Navigation*/

		// if (parametriInfo.HSBTipoRicercaRisorsaUmana !== HSBTipoRicercaRisorsaUmanaEnum.Generiche) {
		// 	return 6;
		// } else {
		// 	return 5;
		// }
		return 5;
	};

	const CreateSteps = (): StepProps[] => {
		let steps: StepProps[] = [];
		let stepValuesDictionary: formStep[] = [];

		for (let stepNumber = 1, stepValue = formStep.Home; stepNumber <= getMaxStepNumber(); stepNumber++) {
			const element: StepProps = {
				className: "step-progress-bar-item",
			};

			stepValuesDictionary.push(stepValue);
			stepValue = getNextStep(stepValue);

			steps.push(element);
		}

		return steps;
	};

	const OnStepClick = (newStep: number) => {
		if (newStep < current) {
			GoToStep(newStep);
		}
	};

	useEffect(() => {
		performAsyncFunction(async () => {
			if (!parametriInfo.HSBTipoRicercaRisorsaUmana) {
				let parametro = await GeneralRepository.HSBTipoRicercaRisorsaUmana();
				HSBTipoRicercaRisorsaUmanaSet(parametro);
			}
		}, handleError);
	}, [parametriInfo.HSBTipoRicercaRisorsaUmana, handleError, HSBTipoRicercaRisorsaUmanaSet]);

	const getDirection = () => {
		var changeWidth = AppStyles.STEP_PROGRES_BAR.DISPLAY_HORIZONTAL_MEDIA_WIDTH;
		return changeWidth >= width || changeWidth === 0 ? "horizontal" : "vertical";
	};

	return (
		<Steps
			aria-hidden={true}
			direction={getDirection()}
			className={"step-progress-bar " + getDirection()}
			current={current}
			responsive={false}
			items={CreateSteps()}
			onChange={OnStepClick}
		></Steps>
	);
};

export default Enhanced(ProgressBar, {});
